import { Dir } from '../dirs';
import http from '../../utils/http';

export function getItemDetails({ id }: Pick<Dir, 'id'>) {
  return http.get<never, any>(`api/reports/item/${id}`);
}
